module.exports = __webpack_public_path__ + "img/linkedin 2.26c9029c.svg";